import React from "react"
import {Typography} from "@mui/material"
import { AppProviderBlock } from "@components"


export default function nameColumn() {
	return {
		name: "id_provider_color", label: "Site",
		options: {
			headerAlign: 'left',
			customBodyRowRenderLite: value => <Typography variant="subtitle1" component="div">
				<AppProviderBlock provider={value}/>
			</Typography>
		}
	}
}